// extracted by mini-css-extract-plugin
module.exports = {"error":"styles-module__error___2T0sf"};